import { io, type Socket } from 'socket.io-client';

let socket: Socket | null = null;
let refs = 0;

export const acquireFrontendSocket = (): Socket => {
  refs += 1;
  if (!socket) {
    socket = io('/frontend', {
      path: '/ws',
      transports: ['websocket', 'polling'],
    });
  }
  return socket;
};

export const getFrontendSocket = (): Socket | null => socket;

export const releaseFrontendSocket = (): void => {
  refs -= 1;
  if (refs <= 0 && socket) {
    socket.disconnect();
    socket = null;
    refs = 0;
  }
};
